import { isArdoqError } from '@ardoq/common-helpers';
import { logError } from '@ardoq/logging';
import {
  catchError,
  distinctUntilChanged,
  map,
  of,
  ReplaySubject,
  share,
  startWith,
  switchMap,
  timer,
} from 'rxjs';
import { currentOrganization$ } from 'streams/organizations/currentOrganization$';
import { orgTriples$ } from '../../streams/orgTriples$';
import {
  buildIntendedRefTypesMap,
  hasConstraints,
} from '../../utils/metamodelConstraints';

const mappedIntendedRefTypes$ = orgTriples$.pipe(
  map(response => {
    if (isArdoqError(response)) {
      return null;
    }
    return response;
  }),
  map(buildIntendedRefTypesMap),
  catchError(err => {
    logError(
      err,
      'Error when building intended ref types map from org triples'
    );
    // If there is an error in the stream, we don't retry.
    // The stream will be re-subscribed the next time the user opens the properties editor.
    return of(null);
  })
);

export const intendedRefTypes$ = currentOrganization$.pipe(
  map(org => {
    if (isArdoqError(org)) {
      return false;
    }
    return hasConstraints(org);
  }),
  distinctUntilChanged(),
  switchMap(needsIntendedRefTypes =>
    needsIntendedRefTypes ? mappedIntendedRefTypes$ : of(null)
  ),
  share({
    connector: () => new ReplaySubject(1),
    resetOnRefCountZero: () => timer(1000),
  }),
  startWith(null)
);
